import { createSlice } from "@reduxjs/toolkit";
interface memberListInter {
  membersList: object;
  singleMemberList: Array<string>;
  RedeemEVoucher: Array<string>;
  utilizedEVoucher: Array<string>;
  carParkLogs: Array<string>;
}
const initialState: memberListInter = {
  membersList: {},
  singleMemberList: [],
  RedeemEVoucher: [],
  utilizedEVoucher: [],
  carParkLogs: []
};

export const memberListSLice = createSlice({
  name: "memberListSlice",
  initialState,
  reducers: {
    updateMemberList(state, action) {
      state.membersList = action.payload.membersList;
    },
    updateSingleMemberList(state, action) {
      state.singleMemberList = action.payload.singleMemberList;
    },
    updateRedeemEVoucher(state, action) {
      state.RedeemEVoucher = action.payload.RedeemEVoucher;
    },
    updateUtilizedEVoucher(state, action) {
      state.utilizedEVoucher = action.payload.utilizedEVoucher;
    },
    updateCarParkLogs(state, action) {
      state.carParkLogs = action.payload.carParkLogs;
    },
    resetMemberSlice: (state) => initialState,
  },
});
export const memberActions = memberListSLice.actions;
export default memberListSLice.reducer;
